import type { BlogCluster } from "@shared/blog";

// Chip copy per frontmatter `cluster` (UI-SPEC section 1, from the cluster plan).
export const CLUSTER_LABELS: Record<BlogCluster, string> = {
  pillar: "الدليل الشامل",
  trust: "الثقة والأمان",
  rights: "حقوقك كمستهلك",
  payment: "الدفع والشحن",
};

export function ClusterChip({ cluster }: { cluster: BlogCluster }) {
  return (
    <span className="text-sm font-bold bg-warmOrange-50 text-warmOrange-700 rounded-full px-2 py-1 inline-block">
      {CLUSTER_LABELS[cluster]}
    </span>
  );
}

export default ClusterChip;
